/**
 * @file: description
 * @author:
 * @Date: 2020-03-11 18:55:07
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2020-03-11 21:20:56
 */
const loader = (name: string) => async () => {
  const entrance = await import(/* webpackChunkName: "f.personal" */ './');
  return entrance[name];
};

import { IRoute } from '@src/types';

export const childRoutes: IRoute[] = [
  {
    load: loader('HomePage'),
    path: 'personal/:userName/:tagId?'
  }
];
export default {
  path: '/',
  name: 'personal',
  childRoutes
};
